// extracted by mini-css-extract-plugin
export default {"loading":"c121ce0ed7c2"};